import httpClient from '@/api/http-client';

const endpoint = 'api/unauthorized-attempts';

const unauthorizedAttemptsService = {
  // create: (attempt) => httpClient.post(`${endpoint}`, attempt),

  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  export: (params) =>
    httpClient({
      url: `${endpoint}-export`,
      method: 'GET',
      responseType: 'blob',
      params: { ...params },
    }),
};

export default unauthorizedAttemptsService;
